export default __webpack_public_path__ + "cloud-import.png";